"use strict";

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es7.object.entries");

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.array.from");

require("core-js/modules/es6.function.name");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.array.is-array");

require("core-js/modules/es6.object.define-property");

function _interopDefault(e) {
  return e && "object" == typeof e && "default" in e ? e["default"] : e;
}

Object.defineProperty(exports, "__esModule", {
  value: !0
});

var React = _interopDefault(require("react"));

function styleInject(e, t) {
  void 0 === t && (t = {});
  var r = t.insertAt;

  if (e && "undefined" != typeof document) {
    var a = document.head || document.getElementsByTagName("head")[0],
        n = document.createElement("style");
    n.type = "text/css", "top" === r && a.firstChild ? a.insertBefore(n, a.firstChild) : a.appendChild(n), n.styleSheet ? n.styleSheet.cssText = e : n.appendChild(document.createTextNode(e));
  }
}

var css_248z = ".button {\n  width: 100%;\n  height: auto;\n  border: 3px solid cyan;\n  border-radius: 4px;\n  padding: 5px 2px;\n  background-color: transparent;\n}\n";
styleInject(css_248z);

var Button = function Button(e) {
  return React.createElement("button", {
    className: "button",
    type: "button",
    alt: e.altText,
    onClick: e.onClick
  }, React.createElement("span", null, e.buttonText));
};

function _slicedToArray(e, t) {
  return _arrayWithHoles(e) || _iterableToArrayLimit(e, t) || _unsupportedIterableToArray(e, t) || _nonIterableRest();
}

function _arrayWithHoles(e) {
  if (Array.isArray(e)) return e;
}

function _iterableToArrayLimit(e, t) {
  if ("undefined" != typeof Symbol && Symbol.iterator in Object(e)) {
    var r = [],
        a = !0,
        n = !1,
        c = void 0;

    try {
      for (var i, l = e[Symbol.iterator](); !(a = (i = l.next()).done) && (r.push(i.value), !t || r.length !== t); a = !0) {
        ;
      }
    } catch (e) {
      n = !0, c = e;
    } finally {
      try {
        a || null == l["return"] || l["return"]();
      } finally {
        if (n) throw c;
      }
    }

    return r;
  }
}

function _unsupportedIterableToArray(e, t) {
  if (e) {
    if ("string" == typeof e) return _arrayLikeToArray(e, t);
    var r = Object.prototype.toString.call(e).slice(8, -1);
    return "Object" === r && e.constructor && (r = e.constructor.name), "Map" === r || "Set" === r ? Array.from(r) : "Arguments" === r || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r) ? _arrayLikeToArray(e, t) : void 0;
  }
}

function _arrayLikeToArray(e, t) {
  (null == t || t > e.length) && (t = e.length);

  for (var r = 0, a = new Array(t); r < t; r++) {
    a[r] = e[r];
  }

  return a;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var css_248z$1 = ".card {\n    border: 3px dashed black;\n    padding: 20px 10px;\n    border-radius: 8px;\n}\n\n.card-image-wrapper {\n    height: 250px;\n    overflow: hidden;\n}\n\nimg.card-image {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n}";
styleInject(css_248z$1);

var Card = function Card(e) {
  var t = e.cardLinks;
  return React.createElement(React.Fragment, null, React.createElement("div", {
    className: "card"
  }, React.createElement("div", {
    className: "card-image-wrapper"
  }, React.createElement("img", {
    className: "card-image",
    src: e.imageSource,
    alt: e.imageAlt
  })), React.createElement("div", {
    className: "card-title"
  }, e.title), React.createElement("div", {
    className: "card-subtitle"
  }, e.subtitle), React.createElement("div", {
    className: "detail-page-link"
  }, React.createElement("a", {
    href: e.detailPageLink
  }, "Read More...")), React.createElement("div", null, e.tags.map(function (e) {
    return React.createElement("span", null, e);
  })), React.createElement("div", {
    className: "card-links"
  }, Object.entries(t).map(function (e) {
    var t = _slicedToArray(e, 2),
        r = t[0],
        a = t[1];

    return React.createElement("div", null, React.createElement("a", {
      href: a,
      target: "_blank"
    }, r));
  }))));
};

exports.Button = Button, exports.Card = Card;